import { connect } from 'react-redux'
import { compose } from 'redux'
import { withRouter } from 'react-router-dom'
import { getBudgetOverview } from '../selectors'
import { setBudgetIgnore } from '../actions'
import BudgetOverview from '../components/budgetOverview'

const mapStateToProps = state => ({
  budget: getBudgetOverview(state),
})

const mapDispatchToProps = dispatch => ({
  setBudgetIgnore: (payload) => {
    dispatch(setBudgetIgnore(payload))
  },
})

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(BudgetOverview)



// WEBPACK FOOTER //
// ./src/modules/budget/containers/budgetOverview.js